import { Languages } from "../../types";
import { ChatPagesDescriptions } from "./types";

const DescriptionsEnUs: ChatPagesDescriptions = {
    TITLE: "ProChat",
    WELCOME_TITLE: "Welcome to ProChat",
    WELCOME_SUBTITLE: "I can help you create quotations and find system information with Artificial Intelligence.",
    INPUT_PLACEHOLDER: "Do you have any questions?",
    SEND_BUTTON: "Send",
    SENDING_BUTTON: "Sending...",
    THINKING: "Thinking",
    DOWNLOAD_PDF: "Download PDF",
    DOWNLOAD_ERROR: "The PDF could not be downloaded.",
    EMPTY_ERROR: "Write a message before sending.",
    REQUEST_ERROR: "Something went wrong while processing your message. Please try again.",
    TOOLS_USED: "Tools used",
    PREFERENCES_TITLE: "Preferences",
    SEND_WITH_ENTER: "Send with Enter",
    SEND_WITH_ENTER_HELP: "When disabled, Enter adds a new line and Shift + Enter sends.",
    SEND_HINT_ENTER: "Enter to send · Shift + Enter for a new line",
    SEND_HINT_SHIFT_ENTER: "Shift + Enter to send · Enter for a new line",
    WARNING: "ProChat can make mistakes.",
    SUGGESTIONS: [
        "Create a quotation",
        "Search for a similar quotation",
        "Update quotation status",
        "Send a quotation to Telegram",
    ],
}

const DescriptionsEsUs: ChatPagesDescriptions = {
    TITLE: "ProChat",
    WELCOME_TITLE: "Bienvenido a ProChat",
    WELCOME_SUBTITLE: "Te ayudaré a crear cotizaciones y encontrar información del sistema con Inteligencia Artificial.",
    INPUT_PLACEHOLDER: "¿Tienes alguna duda?",
    SEND_BUTTON: "Enviar",
    SENDING_BUTTON: "Enviando...",
    THINKING: "Pensando",
    DOWNLOAD_PDF: "Descargar PDF",
    DOWNLOAD_ERROR: "No se pudo descargar el PDF.",
    EMPTY_ERROR: "Escribe un mensaje antes de enviar.",
    REQUEST_ERROR: "Algo salió mal al procesar tu mensaje. Intenta de nuevo.",
    TOOLS_USED: "Herramientas utilizadas",
    PREFERENCES_TITLE: "Preferencias",
    SEND_WITH_ENTER: "Enviar con Enter",
    SEND_WITH_ENTER_HELP: "Si está desactivado, Enter agrega una nueva línea y Shift + Enter envía.",
    SEND_HINT_ENTER: "Enter para enviar · Shift + Enter para nueva línea",
    SEND_HINT_SHIFT_ENTER: "Shift + Enter para enviar · Enter para nueva línea",
    WARNING: "ProChat puede cometer errores",
    SUGGESTIONS: [
        "Crear una cotización",
        "Buscar una cotización similar",
        "Actualizar estado de cotización",
        "Enviar una cotización a Telegram",
    ],
}

const chatDictionary = {}
chatDictionary[Languages.ENGLISH_US] = DescriptionsEnUs
chatDictionary[Languages.SPANISH_US] = DescriptionsEsUs

export const getChatDescriptions = (systemLang: Languages): ChatPagesDescriptions => (
    chatDictionary[systemLang]
)
